import {
  useNavigate,
  unstable_HistoryRouter,
  useLocation,
} from "react-router-dom"
import withRouter from "./Common/withRouter"
import { useEffect, useState } from "react"
import { jwtDecode } from "jwt-decode"

const AuthVerifyComponent = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [count, setCount] = useState(0)

  useEffect(() => {
    // execute on location change
    setCount(count + 1)
    console.log("Location changed!", location.pathname)

    if (localStorage.getItem("cmsAuth")) {
      const jwt_Token_decoded = jwtDecode(localStorage.getItem("cmsAuth"))
      console.log(jwt_Token_decoded.exp * 1000)
      console.log(Date.now())
      if (jwt_Token_decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("cmsAuth")
        navigate(`/login`)
      }
    }
  }, [location])
}

export default withRouter(AuthVerifyComponent)
